import { gql } from "@apollo/client";

export const CLIP_TIMELINE = gql`
  query ClipTimeline($trackId: ID!) {
    clipTimeline(trackId: $trackId) {
      trackId
      clipId
      montageId
      contentType
      game
      queueName
      firstEventAt
      lastEventAt
      overallState
      desktop {
        currentState
        firstEventAt
        lastEventAt
        completedAt
        estimatedCompletionAt
        clipLink
        errorCode
        errorMessage
      }
      mobile {
        currentState
        firstEventAt
        lastEventAt
        completedAt
        estimatedCompletionAt
        clipLink
        errorCode
        errorMessage
      }
      events {
        event
        at
        isMobile
        clipLink
        errorCode
        errorMessage
      }
      clip {
        id
        url(orientation: LANDSCAPE)
        thumbnailUrl(style: STANDARD)
        title
      }
    }
  }
`;

export const MY_IN_TRANSIT_CLIPS = gql`
  query MyInTransitClips($limit: Int) {
    myInTransitClips(limit: $limit) {
      trackId
      clipId
      montageId
      contentType
      game
      queueName
      firstEventAt
      lastEventAt
      overallState
      desktop {
        currentState
        estimatedCompletionAt
        completedAt
        clipLink
        errorCode
        errorMessage
      }
      mobile {
        currentState
        estimatedCompletionAt
        completedAt
        clipLink
        errorCode
        errorMessage
      }
      events {
        event
        at
        isMobile
        clipLink
        errorCode
        errorMessage
      }
      clip {
        id
        url(orientation: LANDSCAPE)
        thumbnailUrl(style: STANDARD)
        title
      }
    }
  }
`;

export const MONTAGE_PROGRESS = gql`
  query MontageProgress($montageId: ID!) {
    montageProgress(montageId: $montageId) {
      montageId
      total
      completed
      inFlight
      errored
      state
      clips {
        trackId
        clipId
        contentType
        game
        queueName
        firstEventAt
        lastEventAt
        overallState
        desktop {
          currentState
          estimatedCompletionAt
          completedAt
          clipLink
          errorCode
          errorMessage
        }
        mobile {
          currentState
          estimatedCompletionAt
          completedAt
          clipLink
          errorCode
          errorMessage
        }
        events {
          event
          at
          isMobile
          clipLink
          errorCode
          errorMessage
        }
      }
    }
  }
`;
